import React from 'react';
import { type EventName, createComponent } from '@lit/react';
import { ThemeProvider } from '@mui/material/styles';
import {
  type UnaAppTileClickedEvent,
  type UnaShowEvent,
  UnaAppLauncher,
} from '@unanet/unafy';
import { theme } from '#/theme';
import { WebComponentLocaleProvider } from '#/locale';
import { useAppLauncher } from './app-launcher.hooks';
import { useStyles } from './AppLauncherComponent.styles';
import type { AppLauncherComponentProps } from './models';
import { parseProps } from './utils';

const AppLauncher = createComponent({
  tagName: 'una-app-launcher',
  elementClass: UnaAppLauncher,
  react: React,
  events: {
    onLauncherOpen: 'una-show' as EventName<UnaShowEvent>,
    onLauncherClose: 'una-hide' as EventName<UnaShowEvent>,
    onLauncherAppClicked:
      'una-app-tile-clicked' as EventName<UnaAppTileClickedEvent>,
  },
});

export const AppLauncherComponent = ({
  apps: appsString,
  issuer: issuerString,
  sandbox: sandboxProp,
  userKey: userKeyProp,
}: AppLauncherComponentProps) => {
  const { classes } = useStyles();

  const { apps, issuer, sandbox, userKey } = parseProps({
    apps: appsString,
    issuer: issuerString,
    sandbox: sandboxProp,
    userKey: userKeyProp,
  });

  const { apps: userApps, loadingState } = useAppLauncher({
    userApps: apps.apps,
    issuer,
    userKey,
  });

  return userApps ? (
    <ThemeProvider theme={theme}>
      <WebComponentLocaleProvider>
        <AppLauncher
          apps={userApps}
          className={`${classes.font} ${
            sandbox ? classes.launcherIconSandbox : classes.launcherIcon
          }`}
          error={loadingState === 'failed'}
        />
      </WebComponentLocaleProvider>
    </ThemeProvider>
  ) : null;
};
